export const dgtekMapEvents = [
  'on-net',
  'footprint',
  'construction-commenced',
  'coming-soon',
  'not-available',
  'list',
  'submit-address'
]
